.form {
  margin-top: 20px;
}

.inputGroup {
  display: grid;
  grid-template-columns: 1fr minmax(0, 2fr);
  margin: 20px 0;
  align-items: center;
}

.productTitle {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-left: 1ch;
}

.invalidText {
  color: var(--sentiment-text-negative);
}

.conditionNotesLabel {
  margin-bottom: 10px;
}